import type { Theme } from '@mui/material'
import type { SystemStyleObject } from '@mui/system'

type IconSize = 12 | 16 | 20 | 24

/**
 * The line thickness for each icon size, in the units of a 24-unit drawing. Shown at its size, each paints 0.9px, 1.075px,
 * 1.25px and 1.4px: a small icon gets a slightly heavier line, so every size looks equally bold.
 */
const LINE_WIDTH_BY_SIZE: Readonly<Record<IconSize, number>> = { 12: 1.8, 16: 1.6125, 20: 1.5, 24: 1.4 }

/** Sizes a line-drawn icon and gives its lines the matching thickness. Filled parts keep their shape. */
export const getIconSizeSx = (size: IconSize): SystemStyleObject<Theme> => ({
    width: size,
    height: size,
    '& [stroke]': { strokeWidth: LINE_WIDTH_BY_SIZE[size] },
})

export const SIDE_BAR_ICON_SIZE = 20
const SIDE_BAR_DRAWING_SCALE = 0.9
/** Paints 0.83px once the drawing is scaled to 90% of its 20px frame */
const SIDE_BAR_LINE_WIDTH = 1.11

type SideBarIconSx = Readonly<{ width: number, height: number, transform: string, '& [stroke]': Readonly<{ strokeWidth: number }> }>

/**
 * Draws a line icon at 90% of its 20px frame with lighter lines. The frame keeps its size and place, so the layout around the
 * icon doesn't move. Filled parts keep their shape, only scaled with the drawing.
 */
export const getSideBarIconSx = (): SideBarIconSx => ({
    width: SIDE_BAR_ICON_SIZE,
    height: SIDE_BAR_ICON_SIZE,
    transform: `scale(${SIDE_BAR_DRAWING_SCALE})`,
    '& [stroke]': { strokeWidth: SIDE_BAR_LINE_WIDTH },
})
